import { makeLocale } from "src/utilities/i18n/makeLocale";
import {
  defaultFormatters,
  LocaleFormatters,
  LocaleTranslations,
} from "../i18nConfig";
import { translations } from "./en-us";

export default makeLocale<LocaleTranslations, LocaleFormatters, "en-gb">({
  tag: "en-gb",
  formatters: defaultFormatters,
  translations,
});
